import { makeObservable, observable } from 'mobx';
import { NavigateFunction } from 'react-router-dom';

import { Space, User, Step } from './entities';
import { authStore } from '../core/stores/auth-store';

export class Context {
  space: Space;

  user: User;

  step: Step;

  // To be used in the Modals
  navigate: NavigateFunction;

  get member() {
    return authStore.currentUser.members.find((member) => member.spaceId === this.space._id);
  }

  constructor() {
    makeObservable(this, {
      space: observable,
      user: observable,
      step: observable,
    });
  }
}

export const context = new Context();
